import { z } from 'zod'
import { route } from '../route-def'

export const PlacesQuerySchema = z.object({ q: z.string().trim().min(2).max(80) })

export const PlaceSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  admin1: z.string().nullable(),
  country: z.string(),
  lat: z.number(),
  lng: z.number(),
})
export type Place = z.infer<typeof PlaceSchema>

export const PlacesResponseSchema = z.object({ items: z.array(PlaceSchema).max(8) })
export type PlacesResponse = z.infer<typeof PlacesResponseSchema>

export const placesRoutes = {
  places: route({
    method: 'GET',
    path: '/api/public/places',
    auth: 'public',
    query: PlacesQuerySchema,
    response: PlacesResponseSchema,
  }),
}
